<template>
  <el-dialog
    top="60px"
    :title="dialogTitle"
    :visible.sync="show"
    width="1000px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="productForm"
      label-width="130px"
      style="height: 560px; overflow-y: scroll; padding-right: 10px"
      :model="productForm"
      :rules="formRules"
      class="product-dialog-form"
    >
      <el-form-item label="产品名称" prop="productName">
        <el-input
          v-model="productForm.productName"
          placeholder="请输入产品名称"
          maxlength="20"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="产品描述" prop="productDescription">
        <el-input
          v-model="productForm.productDescription"
          placeholder="请输入产品描述"
          maxlength="100"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="产品类型" prop="productType">
        <el-select
          v-model="productForm.productType"
          placeholder="请选择产品类型"
        >
          <el-option
            v-for="item in productTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="最低额度(万元)" prop="minQuota">
            <el-input-number
              v-model="productForm.minQuota"
              :controls="false"
              :min="0"
              :step="0.1"
              placeholder="最低额度"
              class="form-input"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最高额度(万元)" prop="maxQuota">
            <el-input-number
              v-model="productForm.maxQuota"
              :controls="false"
              :min="0"
              :step="0.1"
              placeholder="最高额度"
              class="form-input"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="最低年利率(%)" prop="minRate">
            <el-input-number
              v-model="productForm.minRate"
              :controls="false"
              :min="0"
              :max="100"
              :step="0.1"
              placeholder="最低利率"
              class="form-input"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最高年利率(%)" prop="maxRate">
            <el-input-number
              v-model="productForm.maxRate"
              :controls="false"
              :min="0"
              :max="100"
              :step="0.1"
              placeholder="最高利率"
              class="form-input"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="最短期限(月)" prop="minTerm">
            <el-input-number
              v-model="productForm.minTerm"
              :controls="false"
              :min="1"
              :step="1"
              placeholder="最短期限"
              class="form-input"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最长期限(月)" prop="maxTerm">
            <el-input-number
              v-model="productForm.maxTerm"
              :controls="false"
              :min="1"
              :step="1"
              placeholder="最长期限"
              class="form-input"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="产品特点" prop="productFeatures">
        <el-input
          v-model="productForm.productFeatures"
          type="textarea"
          placeholder="请输入产品特点"
          :rows="4"
          maxlength="500"
          show-word-limit
        />
      </el-form-item>

      <el-form-item label="申请条件" prop="applyCondition">
        <el-input
          v-model="productForm.applyCondition"
          type="textarea"
          placeholder="请输入申请条件，每行一条"
          :rows="4"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="申请流程" prop="applyProcess">
        <el-input
          v-model="productForm.applyProcess"
          type="textarea"
          placeholder="请输入申请流程，每行一条"
          :rows="4"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { api_insert, api_update } from '@/api/loans.js';
import constants from '@/utils/constants.js';
export default {
  name: 'ProductDialog',
  data() {
    return {
      productTypeList: constants.productTypeList,
      show: false,
      productForm: {
        id: '',
        productName: '',
        productDescription: '',
        productType: 1,
        minQuota: 0,
        maxQuota: 0,
        minRate: 0,
        maxRate: 0,
        minTerm: 1,
        maxTerm: 1,
        productFeatures: '',
        applyCondition: '',
        applyProcess: ''
      },
      resetFormData: {},
      formRules: {
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        // productDescription: [
        //   { required: true, message: '请输入产品描述', trigger: 'blur' },
        //   { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        // ],
        productType: [
          { required: true, message: '请选择产品类型', trigger: 'change' }
        ],
        minQuota: [
          { required: true, message: '请输入最低额度', trigger: 'blur' },
          {
            type: 'number',
            min: 0,
            message: '最低额度不能小于0',
            trigger: 'blur'
          }
        ],
        maxQuota: [
          { required: true, message: '请输入最高额度', trigger: 'blur' },
          {
            type: 'number',
            min: 0,
            message: '最高额度不能小于0',
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (value < this.productForm.minQuota) {
                callback(new Error('最高额度不能小于最低额度'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        minRate: [
          { required: true, message: '请输入最低年利率', trigger: 'blur' },
          {
            type: 'number',
            min: 0,
            max: 100,
            message: '年利率范围为0-100%',
            trigger: 'blur'
          }
        ],
        maxRate: [
          { required: true, message: '请输入最高年利率', trigger: 'blur' },
          {
            type: 'number',
            min: 0,
            max: 100,
            message: '年利率范围为0-100%',
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (value < this.productForm.minRate) {
                callback(new Error('最高年利率不能小于最低年利率'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        minTerm: [
          { required: true, message: '请输入最短期限', trigger: 'blur' },
          {
            type: 'number',
            min: 1,
            message: '最短期限不能小于1个月',
            trigger: 'blur'
          }
        ],
        maxTerm: [
          { required: true, message: '请输入最长期限', trigger: 'blur' },
          {
            type: 'number',
            min: 1,
            message: '最长期限不能小于1个月',
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (value < this.productForm.minTerm) {
                callback(new Error('最长期限不能小于最短期限'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
        // description: [
        //   { required: true, message: '请输入产品描述', trigger: 'blur' },
        //   {
        //     min: 10,
        //     max: 500,
        //     message: '长度在 10 到 500 个字符',
        //     trigger: 'blur'
        //   }
        // ],
        // requirements: [
        //   { required: true, message: '请输入申请条件', trigger: 'blur' },
        //   {
        //     type: 'array',
        //     min: 1,
        //     message: '至少输入一条申请条件',
        //     trigger: 'blur'
        //   }
        // ]
      }
    };
  },
  computed: {
    dialogTitle() {
      return this.productForm.id ? '编辑产品' : '发布产品';
    }
  },
  created() {
    // 使用JSON.parse(JSON.stringify())实现深拷贝，确保所有嵌套结构都被正确复制
    this.resetFormData = this.$deepClone(this.productForm);
  },
  methods: {
    resetForm() {
      // 使用JSON.parse(JSON.stringify())实现深拷贝，确保所有嵌套结构都被正确复制
      this.productForm = this.$deepClone(this.resetFormData);
      if (this.$refs.productForm) {
        this.$refs.productForm.resetFields();
      }
    },
    handleSubmit() {
      this.$refs.productForm.validate((valid) => {
        if (valid) {
          // 使用JSON.parse(JSON.stringify())实现深拷贝，确保所有嵌套结构都被正确复制
          this.pramas = this.$deepClone(this.productForm);
          if (!this.productForm.id) {
            this.handleAdd(this.pramas);
          } else {
            this.handleUpdate(this.pramas);
          }
        } else {
          return false;
        }
      });
    },
    async handleAdd(params) {
      try {
        await api_insert(params);
        this.$message({
          message: '发布成功',
          type: 'success'
        });
        this.handleClose();
        this.$emit('refresh');
      } catch (error) {
        console.log(error);
      }
    },
    async handleUpdate(params) {
      try {
        await api_update(params);
        this.$message({
          message: '更新成功',
          type: 'success'
        });
        this.handleClose();
        this.$emit('refresh');
      } catch (error) {
        console.log(error);
      }
    },
    openDialog(_data = {}) {
      if (_data?.id) {
        this.productForm = {
          ...this.resetFormData,
          ..._data
        };
      }
      this.show = true;
    },
    handleClose() {
      this.resetForm();
      this.show = false;
    }
  }
};
</script>

<style scoped>
.product-dialog-form {
  padding: 0 10px;
}

.form-row {
  display: flex;
  justify-content: space-between;
}

.form-input {
  width: 200px;
}

.dialog-footer {
  text-align: right;
}
</style>
